// extracted by mini-css-extract-plugin
export default {"page":"a6AGY","inner":"i9u9V","title":"ohwe7","swiper":"Wdsg_","main":"NzJPa","question":"nsPlH","answers":"JwCbe","emptyAnswers":"njohd","actions":"Ct0Ww"};